import { endOfDay, format } from 'date-fns'
import { useCallback } from 'react'
import { type PopupState, popupStorage, getPopupKey } from '../utils/popupStorage'

export const FORMAT = 'yyyy-MM-dd HH:mm:ss'

export const usePopupTriggerService = () => {
  /**
   * 標記彈窗已顯示過
   * @param popupId
   */
  const markPopupShown = useCallback((popupId: string) => {
    const storage = popupStorage.get()
    const popupKey = getPopupKey(popupId)
    const now = new Date()

    const updateState = (state: PopupState = { triggeredTimes: 0 }): PopupState => ({
      ...state,
      lastTriggered: format(now, FORMAT),
      triggeredTimes: (state.triggeredTimes || 0) + 1,
    })

    popupStorage.set({
      ...storage,
      [popupKey]: updateState(storage[popupKey]),
      global: updateState(storage.global),
    })
  }, [])

  /**
   * 標記彈窗今日不再顯示
   * @param popupId
   */
  const suppressToday = useCallback((popupId: string) => {
    const now = new Date()
    popupStorage.updatePopup(popupId, state => ({
      ...state,
      suppressUntil: format(endOfDay(now), FORMAT),
    }))
  }, [])

  return {
    markPopupShown,
    suppressToday,
  }
}
